export const addHashClickAndCopyHtml = ({ hash }: { hash: string }): string => {
  const text = `
        <b>Hash</b>: 
        <code 
            class="bg-light p-2 rounded d-inline-block text-break" 
            style="cursor: pointer; user-select: all;" 
            onclick="
                navigator.clipboard.writeText('${hash.replace(/'/g, "\\'")}');
                window.dispatchEvent(new CustomEvent('modalMessage', { 
                    detail: { text: 'Hash copiada com sucesso!', type: 'success' } 
                }));
            "
            title="Clique para copiar"
        >
            ${hash}
        </code>
    `;
  return text;
};
